import React from 'react'
import { NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import {
  AdminPanelSettingsOutlined as AdminIcon,
  DashboardRounded as BusinessIcon,
  FavoriteBorderOutlined as FavoritesIcon,
  LocalOfferOutlined as ClaimedIcon,
  NotificationsActiveOutlined as AlertsIcon,
  PersonRounded as ProfileIcon,
  ExitToAppRounded as LogoutIcon,
} from '@mui/icons-material'
import * as userActions from 'modules/User/actions'
import { useBusinessUser, useAdminUser } from 'utils/roles'

export const businessAccountItem = {
  label: 'My business',
  path: '/business',
  Icon: BusinessIcon,
}

export const accountItems = [
  { label: 'Favorites', path: '/account/my-favorites', Icon: FavoritesIcon },
  { label: 'Claimed', path: '/account/claimed', Icon: ClaimedIcon },
  { label: 'Alerts', path: '/account/my-alerts', Icon: AlertsIcon },
  { label: 'Profile', path: '/account/my-information', Icon: ProfileIcon },
]

export const getAccountItems = (businessUser, admin = false) => [
  ...(admin ? [{ label: 'Admin console', path: '/admin', Icon: AdminIcon }] : []),
  ...(businessUser || admin ? [businessAccountItem] : []), ...accountItems,
]

const AccountMenuItems = ({ onNavigate, showIcons = true }) => {
  const dispatch = useDispatch()
  const businessUser = useBusinessUser()
  const admin = useAdminUser()

  const icon = (Icon) => showIcons && (
    <ListItemIcon sx={{ minWidth: 40 }}>
      <Icon />
    </ListItemIcon>
  )

  return (
    <>
      {getAccountItems(businessUser, admin).map(({ label, path, Icon }) => (
        <ListItem button component={NavLink} to={path} onClick={onNavigate} key={path}>
          {icon(Icon)}
          <ListItemText primary={label} />
        </ListItem>
      ))}
      <ListItem
        button
        onClick={() => {
          onNavigate?.()
          dispatch(userActions.logoutUser())
        }}
      >
        {icon(LogoutIcon)}
        <ListItemText primary="Logout" />
      </ListItem>
    </>
  )
}

export default AccountMenuItems
